/**
 * Lab sample media + track metadata (no Pentecost+ branding).
 * VTT content inlined so CRA can serve without extra static hosting.
 */

export var LAB_MP4 =
  "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4";

export var LAB_HLS =
  "https://devstreaming-media.apple.com/videos/streaming/examples/img_bipbop_adv_example_fmp4/master.m3u8";

export var LAB_VTT_EN = `WEBVTT

00:00:00.500 --> 00:00:04.000
[EN] Welcome to the Next-Gen Player lab.

00:00:04.500 --> 00:00:09.000
[EN] These captions are WebVTT delivered by the subtitles plugin.

00:00:09.500 --> 00:00:14.000
[EN] Press C to toggle subtitles. Use the captions menu to switch tracks.
`;

export var LAB_VTT_ES = `WEBVTT

00:00:00.500 --> 00:00:04.000
[ES] Bienvenido al laboratorio del reproductor.

00:00:04.500 --> 00:00:09.000
[ES] Estos subtítulos WebVTT los carga el plugin de subtítulos.

00:00:09.500 --> 00:00:14.000
[ES] Pulsa C para activar o desactivar los subtítulos.
`;

export var LAB_CHAPTERS = [
  { id: "intro", start: 0, title: "Opening" },
  { id: "act1", start: 30, title: "Act One" },
  { id: "act2", start: 90, title: "Act Two" },
  { id: "end", start: 180, title: "Finale" },
];

/**
 * Config-level audio track descriptors (native switching when AudioTrackList exists).
 */
export var LAB_AUDIO_TRACKS = [
  {
    id: "original",
    label: "Original",
    language: "en",
    kind: "main",
    default: true,
  },
  {
    id: "commentary",
    label: "Commentary (demo)",
    language: "en",
    kind: "commentary",
  },
  {
    id: "es-dub",
    label: "Spanish (demo)",
    language: "es",
    kind: "translation",
  },
];

export var LAB_SUBTITLES = [
  {
    id: "en",
    label: "English",
    language: "en",
    content: LAB_VTT_EN,
    default: true,
    format: "webvtt",
  },
  {
    id: "es",
    label: "Español",
    language: "es",
    content: LAB_VTT_ES,
    format: "webvtt",
  },
];
